module.exports = __webpack_public_path__ + "media/music/piano_5-f0d1b7f1.mp3";